import { render, staticRenderFns } from "./customizedReport.vue?vue&type=template&id=04a45730&scoped=true"
import script from "./customizedReport.vue?vue&type=script&lang=js"
export * from "./customizedReport.vue?vue&type=script&lang=js"
import style0 from "./customizedReport.vue?vue&type=style&index=0&id=04a45730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a45730",
  null
  
)

export default component.exports